import { compose, withProps } from 'recompose';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { withTheme } from 'styled-components';
import withDeviceInfo from 'ggApp/shared/components/viewport/withDeviceInfo';

import {
    storeActive as activeStoreSelector,
    isPartnerStore as isActiveStorePartnerSelector,
} from 'ggApp/modules/store/selectors';
import { orderActive as orderActiveSelector } from 'ggApp/modules/order/selectors';

import Header from './Header';

const enhance = compose(
    withDeviceInfo,
    withTheme,
    connect(
        createStructuredSelector({
            storeActive: activeStoreSelector,
            isPartnerStore: isActiveStorePartnerSelector,
            order: orderActiveSelector,
        }),
    ),
    withProps(({ userDevice }) => ({
        isMobileUser: userDevice === 'mobile',
    })),
);

export default enhance(Header);
